import React from "react";
import {Box, Breadcrumbs, Button, Container, Link, Typography} from "@mui/material";
import {Link as Rlink} from "react-router-dom"
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

const Download = () => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = process.env.REACT_APP_DOWNLOAD_URL;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Box
      sx={{
        alignItems: "center",
        justifyContent: "center",
        color: "white",
        textAlign: "center",
      }}
    >
      <Container sx={{mt: 12}} maxWidth={"lg"}>
        <Breadcrumbs aria-label="breadcrumb" sx={{mb: 8}}>
          <Link component={Rlink} underline="hover" color="inherit" to="/">
            Home
          </Link>
          <Link
            component={Rlink}
            underline="hover"
            color="inherit"
            to={"/download"}
          >
            <Typography color={"textPrimary"}>Download</Typography>
          </Link>
        </Breadcrumbs>
        <Typography variant="h2">
          Welcome to Gamearena
        </Typography>
        <Typography color={"textSecondary"} variant="h5" sx={{mt: 2, mb: 6}}>
          Take your Gaming Experience anywhere With Gamearena
        </Typography>
        <Button
          variant="contained"
          color="primary"
          size="large"
          startIcon={<CloudDownloadIcon/>}
          onClick={handleDownload}
        >
          Download Now
        </Button>
        <Typography variant="body2" color={"textSecondary"} sx={{mt: 3, opacity: 0.67}}>
          * Currently for Windows PC and NVIDIA GPU.
        </Typography>
        <Typography variant="body2" color={"textSecondary"} sx={{mt: 1, opacity: 0.67}}>
          If you want to use it on a laptop, ensure you have a dedicated GPU only mode
        </Typography>
      </Container>
    </Box>
  );
};

export default Download;
